import React, { useEffect, useState, SyntheticEvent, ChangeEvent, FormEvent, useRef } from "react";
//import "./productstable.css";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useNavigate } from 'react-router-dom';

import { Backdrop, Dialog, DialogActions, DialogTitle, Fade, IconButton, MenuItem, Modal, TextField, makeStyles, styled } from "@mui/material";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { ProductService } from "../../service/product.service";
import { BrandsService } from "../../service/brands.service";
import { Brand } from "../../model/brand.model";
import { Category } from "../../model/category.model";
import { CategoryService } from "../../service/categories.service";

import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import { sendFileToServer } from "../../service/fileupload.service";
import ClearIcon from '@mui/icons-material/Clear';
// import readXlsxFile, { Integer } from 'read-excel-file'

import logo from '../../file_ref_img.jpg';
import ErrorModal from '../../common/Modal';
import CSVFileValidator from 'csv-file-validator';
//import EnterpriseUserDialog from "../customers/enterprise/EnterpriseUserDialog";

import CloseIcon from '@mui/icons-material/Close';
//import ChooseOptions from "./ChooseOptions";
import { faL } from "@fortawesome/free-solid-svg-icons";

import './batchprocessing.css';

import MyCustomNotification from "../../common/MyCustomNotification";


// https://www.npmjs.com/package/csv-file-validator -- using this
// https://www.npmjs.com/package/read-excel-file

function BatchProcessing() {

  const [isLoading, setIsLoading] = useState(false);

  const [selectedAction, setSelectedAction] = useState("0");
  const [filteredOrders, setFilteredOrders] = useState<any[]>([]);
  const [selectedItem, setSelectedItem] = useState("0");
  const [fileLoadState, setfileLoadState] = useState("");
  const uploadService = new sendFileToServer();
  const productSvc = new ProductService();
  const brandsService = new BrandsService();
  const categoryService = new CategoryService();
  const [excelFile, setExcelFile] = React.useState("");
  const [excelFileData, setExcelFileData] = React.useState("");
  const [showFilePicker, setshowFilePicker] = useState(false);
  const [showBrands, setshowBrands] = useState(false);
  const [showMainCategories, setshowMainCategories] = useState(false);
  const [showSubCategories, setshowSubCategories] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(0);
  const [availableBrands, setAvailableBrands] = useState<Brand[]>([]);
  const [availableCategories, setAvailableCategories] = useState<Category[]>([]);
  const [availableSubCategories, setAvailableSubCategories] = useState<Category[]>([]);
  const [subCategoryId, setsubCategoryId] = useState(0);
  const [maincategoryId, setMainCategoryId] = useState(0);
  const [batchId, setBatchId] = useState("");
  const navigate = useNavigate();

  const [imagesInCSV, setImagesInCSV] = useState<any[]>([]);

  const [showFileUploads, setShowFileUploads] = useState(false);




  const isValidName = (param: any) => {
    var specialCharsss = /[`!@#$%^&*()+\-=\[\]{};':"\\|,<>\/?~\ ]/;
    return !specialCharsss.test(param)
  }




  useEffect(() => {

    if (!showFileUploads) {
      setFilteredOrders([])
    }
  }, [showFileUploads]);


  let iscalled = false
  useEffect(() => {

    //var  specialCharsss = /[`!@#$%^&*()+\-=\[\]{};':"\\|,.<>\/?~\ ]/;
    //console.log( "charrrrrrrrrr   " + isValidName("hrllooo!po") )


    if (!iscalled) {

      iscalled = true
      const feature = filteredOrders

      //  feature.push({fileName:"file1"})
      //  feature.push({fileName:"file2"})
      setFilteredOrders([...feature])

      console.log("date:: " + formatDate(new Date()));

      loadDBSchema()
    }
  }, []);


  const [dbSchema, setDBSchema] = useState<any[]>([]);
  const [selectedSchema, setSelectedSchema] = useState<any[]>([]);
  const loadDBSchema = () => {

    uploadService.getProductListMasterSchema().then(response => {

      const res = response.data;
      //  let result = Array.isArray(res);
      console.log('finishesData :::  ', res)

      /*  var cnt1 = 0;
        const schemaEdited = res.map((person: any, index: any) => {
          cnt1 = cnt1 + 1;
  
          return {
            ...person,
            id: person.entId,
            chooseByUser: true
  
          };
  
        });
  
        setSelectedSchema(schemaEdited); */

      setDBSchema(res);


      console.log('dbschemaa', dbSchema)

      // let cnt1 = 0;
      //   productSchema = response.data;

      //  res.map((person: any, index: any) => {

      //    console.log("sssss ", person);         

      // });


    });

  }

  var validationString = "";
  const onUploadCsv = (event: SyntheticEvent) => {
    const element = event.target as HTMLInputElement;
    if (element.files) {

      const file = element.files[0];

      let fileName = file.name

      if (!isValidName(fileName)) {

        setDlgOpen(true);

        return
      }


      var headerarr: any[] = [];
      const configone = null;

      console.log('finishesData ------- ', selectedSchema)

      var cnt = 0;
      for (cnt = 0; cnt < selectedSchema.length; cnt++) {
        var obj = null;

        if (selectedSchema[cnt].chooseByUser) {

          if (selectedSchema[cnt].validate) {
            var validtionparam = selectedSchema[cnt].validate;;//productSchema[cnt].validate;

            //  var validationString = "";
            var counetr = 0;
            validtionparam.forEach((key: any) => {
              // 👇️ name Bobby, country Chile
              console.log(key);
              validationString = validationString + "," + key;
              counetr++;
            });

            var fileParam = false;

            if (selectedSchema[cnt].isFile) {
              fileParam = true;
            }

            console.log("pppppp :: " + validationString)
            obj = {
              name: selectedSchema[cnt].name,
              inputName: selectedSchema[cnt].inputName,
              required: selectedSchema[cnt].required,
              isFile: fileParam,
              validate: function (param: any) {
                console.log("cehcking :: " + validationString + " : " + param + ": " + cnt)

                if (validationString.includes("" + param)) {
                  return true;
                } else {
                  return false;
                }

              }
            }
          } else {
            var fileParam = false;

            if (selectedSchema[cnt].isFile) {
              fileParam = true;
            }
            obj = {
              name: selectedSchema[cnt].name,
              inputName: selectedSchema[cnt].inputName,
              required: selectedSchema[cnt].required,              
              isFile: fileParam,
            }
          }
          headerarr.push(obj);
        }


      }

      console.log("headeerrr : " + headerarr)


      const config =

      {
        headers: headerarr
      }


      CSVFileValidator(file, config)
        .then(csvData => {

          if (csvData.inValidData.length != 0) {
            var cnt = 0;
            for (cnt = 0; cnt < csvData.inValidData.length; cnt++) {
              console.log("data error :: " + csvData.inValidData[cnt].message)
            }

            const formattedErrors = csvData.inValidData.map((error) => {
              return {
                error: error.message

              };
            });

            setErrors(formattedErrors);
            setShowModal(true);
          } else {
            var cnt = 0;
            console.log("data ::-- " + JSON.stringify(csvData.data));
            var finalcsvdata = "";
            var schemaColumns = "";


            for (count = 0; count < selectedSchema.length; count++) {
              console.log("valllllll :: " + selectedSchema[count].chooseByUser);
              if (selectedSchema[count].chooseByUser) {

                if (schemaColumns != "") {
                  schemaColumns = schemaColumns + "," + selectedSchema[count].name
                } else {
                  schemaColumns = selectedSchema[count].name
                }

                //  schemaColumns =  schemaColumns + ","+ selectedSchema[count].name
              }
            }

            var columns = "";  //"ProductCategoryId,BrandId,ProductCode,ModelNumber,GroupModelNumber,ProductDisplayName,Status,DisplayImage,CadDrawing,ReferenceImage,VideoUrl,Size,Finish,FeatureList,MRP,Stock,New,Remark";

            var prependFields = "";
            switch (selectedItem) {
              case "1":


                if (selectedAction == '1'){
  
                  prependFields = subCategoryId + "," + selectedBrand+ ",";
                  columns = "ProductCategoryId,BrandId," + schemaColumns;

                } else {
                   columns = schemaColumns;
                }

             
                break;
              case "2":

                columns = "" + schemaColumns.split(",")[1];
                break;
              case "3":
                prependFields = selectedBrand + ",";

                columns = "BrandId," + schemaColumns;
                break;
              case "4":
                prependFields = maincategoryId + "," + selectedBrand +",";

                columns = "CategoryParentId,BrandId," + schemaColumns;
                break;

              case "5":
                // prependFields = maincategoryId + "," + selectedBrand ;

                columns = schemaColumns;
                break;
              case "6": // for sizes
                prependFields = selectedBrand + ",";  
  
                columns = "BrandId," + schemaColumns;
                break;
              case "7": // for finish
                prependFields = selectedBrand + ",";  
  
                columns = "BrandId," + schemaColumns;
                break;
            }

            var imageinCSVlistlocal: any[] = []

            for (cnt = 0; cnt < csvData.data.length; cnt++) {

              //  console.log("valllllll :: "+  Object(csvData.data[cnt])["productDisplayName"])

              var param1 = "";
              var count = 0;
              for (count = 0; count < selectedSchema.length; count++) {
                // console.log("valllllll :: "+  productSchema[count].inputName);

                if (selectedSchema[count].chooseByUser) {
                  let valuee = Object(csvData.data[cnt])[selectedSchema[count].inputName]

                  if (param1 != "") {
                    param1 = param1 + "," + valuee //Object(csvData.data[cnt])[selectedSchema[count].inputName]
                  } else {
                    param1 = valuee //Object(csvData.data[cnt])[selectedSchema[count].inputName]
                  }


                  if (selectedSchema[count].isFile) {
                    imageinCSVlistlocal.push(valuee)
                  }
                }
              }

              var tempdata = prependFields  + param1 
              // subCategoryId + "," +
              // selectedBrand  +param1

              if (finalcsvdata != "") {
                finalcsvdata = finalcsvdata + "\n" + tempdata
              } else {
                finalcsvdata = columns + "\n" + tempdata
              }
            }

            var filesInCSV = [...imageinCSVlistlocal];
            setImagesInCSV(filesInCSV)


            console.log("data :: csvdata ===  " + finalcsvdata)

            var encodedString = "data:text/csv;base64," + btoa(finalcsvdata);

            console.log("data :: base64 ===  " + encodedString)

            setExcelFile(file.name);
            setExcelFileData(encodedString)

          }




          // csvData.data // Array of objects from file
          // csvData.inValidData // Array of error messages

        })
        .catch(err => {

          console.log("file upload error : "+ err)

         })

      console.log("^^^CatImg^^^^^^^^^^^file : " + file.name);
      /* const reader = new FileReader()
       reader.readAsDataURL(file)
       reader.onload = () => {
 
       //  setExcelFile(file.name);
       //  setExcelFileData(reader.result as string);
 
        //  console.log("^^^CatImg^^^^^^^^^^^file data : " + reader.result as string);
       }
       reader.onerror = (e) => { console.log('err') } */
    }
  }

  /*const onUploadExcel = (event: SyntheticEvent) => {
    const element = event.target as HTMLInputElement;
    if (element.files) {

      const file = element.files[0];

      const schema = {
        'ModelNumber': {
          // JSON object property name.
          prop: 'modelNumber',
          type: String,
          required: true
        },
        'GroupModelNumber': {
          prop: 'groupModelNumber',
          type: String
        },
        'ProductDisplayName': {
          prop: 'productDisplayName',
          type: String,
          required: true
        },
        'Status': {
          prop: 'status',
          type: Number,
          required: true,
          oneOf: [
            0,
            1
          ]
        },
        'ProductCode': {
          prop: 'productCode',
          type: String,
          required: true
        },

        'CadDrawing': {
          prop: 'cadDrawing',
          type: String

        },
        'ReferenceImage': {
          prop: 'referenceImage',
          type: String

        },
        'VideoUrl': {
          prop: 'videoUrl',
          type: String

        },

        'Size': {
          prop: 'size',
          type: String,
          required: true
        },

        'Finish': {
          prop: 'finish',
          type: String,
          required: true
        }
        ,
        'FeatureList': {
          prop: 'featureList',
          type: String

        },
        'MRP': {
          prop: 'mrp',
          type: Number,
          required: true
        },
        'Stock': {
          prop: 'stock',
          type: Number,
          required: true
        },
        'New': {
          prop: 'new',
          type: String,
          required: true,
          oneOf: [
            'Y',
            'N'
          ]
        },
        'Remark': {
          prop: 'remark',
          type: String
        },
      }

      readXlsxFile(file, { schema }).then(({ rows, errors }) => {
        // Handle and format the errors
        console.log("errors : " + errors.length);
        if (errors.length > 0) {
          const formattedErrors = errors.map((error) => {
            return {
              column: error.column,
              error: error.error,
              reason: error.reason || "Reason not provided", // Provide a default value here
              value: error.value,
              row: error.row,
            };
          });

          setErrors(formattedErrors);
          setShowModal(true);
          console.log("Errors:", formattedErrors);
        } else {
          console.log("No errors found.");
        }
      }).catch((error) => {
        console.error("Error reading Excel file:", error);
      });


      // readXlsxFile(file, { schema }).then(({ rows, errors }) => {
      // //  console.log("row : errors ::  "+errors);
      //   var cnt;
      //   for (cnt = 0; cnt < errors.length; cnt++) 
      //   {
      //     console.log("error: "+errors[cnt].column +" : " +errors[cnt].error + " : "+errors[cnt].reason + " : "+errors[cnt].value
      //     + " : "+errors[cnt].row)
      //   }
      //   //error: Status : required : undefined : null : 3

      //   // `rows` is an array of rows
      //   // each row being an array of cells.
      // })
      

      console.log("^^^CatImg^^^^^^^^^^^file : " + file.name);
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setExcelFile(file.name);
        setExcelFileData(reader.result as string);

        // console.log("^^^CatImg^^^^^^^^^^^file data : " + reader.result as string);
      }
      reader.onerror = (e) => { console.log('err') }
    }
  } */


  const onUploadFileList = (event: SyntheticEvent) => {

    const element = event.target as HTMLInputElement;
    let cnt = 0;
    console.log("filess ", element.files);

    const listt = element.files as FileList
    if (!element.files) {
      return
    }
    const feature = filteredOrders
    for (cnt = 0; cnt < listt.length; cnt++) {
      const file = element.files[cnt];

      console.log("^^^^^refImg^^^^^^^^^file : " + cnt + file.name);


      const reader = new FileReader()

      reader.readAsDataURL(file)

      // feature.push({fileName:file.name ,fileData:"" })

      reader.onload = () => {

        feature.push({ fileName: file.name, fileData: reader.result as string })
        console.log("final ::: ", feature)
        setFilteredOrders([...feature])
      }
      reader.onerror = (e) => { console.log('err') }

    }
    console.log("final : ", feature)

    // setFilteredOrders([...feature])
  }

  var imagereqCnt = 0;
  var imageresCnt = 0;
  var loopCnt = 0;
  var outerLoop = 0;
  const [errMsg, setErrMsg] = useState('');
  const uploadAllfiles = () => {

    // do validation
    var missingFiles: any[] = [];

    if (showFileUploads) {


      if (imagesInCSV.length > 0 && filteredOrders.length == 0) {

        missingFiles.push("image file(s) ");
      } else {

      var count1 = 0;
      for (count1 = 0; count1 < imagesInCSV.length; count1++) {

       if ( imagesInCSV[count1] == "\"\"" ) {
            continue;
       }

        var count2 = 0;
        var missingFileLocal = "";
        for (count2 = 0; count2 < filteredOrders.length; count2++) {
          console.log("dataaa ::::: ====== " + imagesInCSV[count1] + " : " + filteredOrders[count2].fileName)
          if (imagesInCSV[count1] == filteredOrders[count2].fileName   ) {
            missingFileLocal = "";
            break;
          } else {
            missingFileLocal = imagesInCSV[count1]
          }
        }
        if (missingFileLocal != "") {
          missingFiles.push(missingFileLocal)
        }
      }
    }

      console.log("missing file ::::: ====== " + missingFiles);

      if (missingFiles.length > 0) {

        const formattedErrors = missingFiles.map((error) => {
          return {
            error: error + " is missing "

          };
        });

        setErrors(formattedErrors);
        setShowModal(true);

        return;
      }

    }

    if (filteredOrders.length == 0) {
      setIsLoading(true)
      uploadCsv();
      return
    }

    //////


    let cnt = 0;
    let limit = 5;
    let filesCnt = 0;
    //  if (filteredOrders.length > limit) {

    if (filteredOrders.length <= limit) {
      outerLoop = 1
    } else {
      outerLoop = Math.ceil((filteredOrders.length) / limit)
    }
    imageresCnt = outerLoop;
    console.log("outerLoop ", outerLoop);
    for (cnt = 0; cnt < outerLoop; cnt++) {
      let cnt1 = 0;
      let datalocal: any[] = []
      if (filteredOrders.length - (cnt * limit) > limit) {
        loopCnt = limit;
      } else {
        loopCnt = filteredOrders.length - (cnt * limit)
      }
      for (cnt1 = 0; cnt1 < loopCnt; cnt1++) {
        //if (filteredOrders[cnt1]!=null) {
        datalocal.push(filteredOrders[cnt1 + (cnt * limit)])
        // }
      }
      console.log("all data ", datalocal);
      let uploadData = { "files": datalocal, "batchId": batchId }
      setIsLoading(true)
      uploadService.batchImageUpload(uploadData).then(data => {
        // TODO : sai check the status value 
        if (data != null) {
          if (data.status == 100) {
            imagereqCnt = imagereqCnt + 1;
            console.log("imgresp : " + imagereqCnt + " : " + imageresCnt);
            if (imagereqCnt == imageresCnt) {
              uploadCsv();
            }
          } else {
            setIsLoading(false)
            imagereqCnt = 0;
            toast.error("Batch Process Failed !!!", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 2000,
              hideProgressBar: true,
            });
            setTimeout(() => {
              navigate("../batchprocessing");
            }, 2100);

          }
        }

      });
    }

    // uploadCsv();
    //  } else {
    //    let datalocal: any[] = []
    //    for (cnt = 0; cnt < (filteredOrders.length) / limit; cnt++) {
    //      datalocal.push(filteredOrders[cnt])
    //    }
    //   console.log("all data ", datalocal);
    //    let uploadData = { "files": datalocal , "batchId":batchId}
    //    uploadService.batchImageUpload(uploadData).then(data => {
    //     const res = data.data;
    //     uploadCsv();
    //    });
    //}



    /* const batchdata = {
       "action": selectedAction,
       "item": selectedItem,
       "batchId": batchId,
       "brandId": selectedBrand,
       "catId": maincategoryId,
       "subcatId": subCategoryId,
       "csvFile": excelFile,
       "csvFileData": excelFileData
     };
 
     uploadService.processBatchData(batchdata) */

  }

  function uploadCsv() {
    const batchdata = {
      "action": selectedAction,
      "item": selectedItem,
      "batchId": batchId,
      "brandId": selectedBrand,
      "catId": maincategoryId,
      "subcatId": subCategoryId,
      "csvFile": excelFile,
      "csvFileData": excelFileData
    };

    uploadService.processBatchData(batchdata).then(data => {
      // TODO : sai check the status value 
      if (data) {
        if (data.status == 100) {
          setIsLoading(false)
          toast.success("Batch Upload Successfull !!!", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            hideProgressBar: true,
          });
          setTimeout(() => {
            navigate("../batchprocessing");
          }, 2100);
        } else {
          setIsLoading(false)
          toast.error("Batch Upload Failed !!!", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            hideProgressBar: true,
          });
          setTimeout(() => {
            navigate("../batchprocessing");
          }, 2100);
        }
      }
    });
  }

  function padTo2Digits(num: number) {
    return num.toString().padStart(2, '0');
  }

  function formatDate(date: Date) {
    return Date.now() + "";
  }

  /*function formatDate(date: Date) {
    return (
      [
        date.getFullYear(),
        padTo2Digits(date.getMonth() + 1),
        padTo2Digits(date.getDate()),
      ].join('') +
      '_' +
      [
        padTo2Digits(date.getHours()),
        padTo2Digits(date.getMinutes()),
        padTo2Digits(date.getSeconds()),
        padTo2Digits(date.getMilliseconds())
      ].join('')
    );
  } */


  const divStyle = {
    overflowY: 'scroll',
    border: '1px solid red',
    width: '500px',
    float: 'left',
    height: '500px',
    position: 'relative'
  };

  const myComponent = {
    backgroundColor: "#F2F2F3",
    height: '200px',
    overflow: 'scroll'
  };

  const imgComponent = {
    height: '25px'
    // display: inline-block

  };


  const onRemoveFeature = (index: number) => {
    filteredOrders.splice(index, 1);
    setFilteredOrders([...filteredOrders]);
    console.log("count :: " + filteredOrders)
  }

  const onCancel = () => {
    filteredOrders.splice(0, filteredOrders.length);
    setFilteredOrders([...filteredOrders]);
  }

  const loadAllBrands = () => {
    brandsService.brands(1).then(data => {
      const res = data.data;
      setAvailableBrands(res);
      // console.log("availableBrands : ", availableBrands)
    });
  }

  const loadSubCategories = (scatId: number) => {
    if (!selectedBrand) {
      return;
    }
    setMainCategoryId(scatId)
    categoryService.subCategories(Number(selectedBrand), scatId).then(data => {
      const res = data.data;
      const sCats: Category[] = res.filter((el: any) => el.parentId === scatId);
      setAvailableSubCategories(sCats);
    }).catch(err => {
      setAvailableSubCategories([]);
    });
  }

  const loadAllCategories = (brand: number | string) => {

    categoryService.categories(Number(brand)).then(data => {
      const res = data.data;
      setAvailableCategories(res);

      /* if (res[0]) {
         loadSubCategories(res[0].catId);
       }*/
    });
  }

  useEffect(() => {


    console.log('selectedSchema', selectedSchema)

  }, [selectedSchema])


  useEffect(() => {

    console.log('dbschemaa', dbSchema)

    // console.log('dbschemaa', selectedSchema)

  }, [dbSchema])


  useEffect(() => {
    var action = "";
    switch (selectedAction) {
      case "1":
        action = "C"
        //setshowOnlyProduct(false)
        break;
      case "2":
        action = "U"
        // setshowOnlyProduct(true)
        break;
      case "3":
        action = "D"
        break;
    }


    switch (selectedItem) {
      case "1": // for product update and create
      //  setBatchId(action + "_" + formatDate(new Date()) + "_" + selectedBrand + "_" + maincategoryId + "_" + subCategoryId)

        if (selectedAction == "1") {
          setBatchId(action + "_" + formatDate(new Date()) + "_" + selectedBrand + "_" + maincategoryId + "_" + subCategoryId)
          setShowFileUploads(true)
        } else {
          setBatchId(action + "_" + formatDate(new Date()))
          setShowFileUploads(false)
        }

        var cnt1 = 0;
        const schemaEdited = dbSchema[0].Product.map((person: any, index: any) => {
          cnt1 = cnt1 + 1;
          var disableedit = false;
          var checkedView = false;
          if (selectedAction == "1") {
            disableedit = true;
            checkedView = true;

          } else  if (selectedAction == "2" ) {
              if (person.name == 'vcProductCode') {
                 checkedView =  true ;
                 disableedit = true;
              }
          }

          //

          return {
            ...person,
            id:cnt1 , //person.entId,
            chooseByUser: checkedView,
            disableView: disableedit
          };

        });

        setSelectedSchema(schemaEdited);


        //  setSelectedSchema(dbSchema[0].Product)
        break;
      case "2": // brand creation
        setBatchId(action + "_" + formatDate(new Date()))

        if (selectedAction == "1") {
          setShowFileUploads(true)
        } else {
          setShowFileUploads(false)
        }

        var cnt1 = 0;
        const schemaEdited1 = dbSchema[1].Brand.map((person: any, index: any) => {
          cnt1 = cnt1 + 1;
          var disableedit = false;
          var checkedView = false;
          if (selectedAction == "1") {
            disableedit = true;
            checkedView = true;
          }

          return {
            ...person,
            id: cnt1,//person.entId,
            chooseByUser: checkedView,
            disableView: disableedit
          };

        });

        setSelectedSchema(schemaEdited1);
        break;
      case "3": // main category creation
        setBatchId(action + "_" + formatDate(new Date()) + "_" + selectedBrand)

        if (selectedAction == "1") {
          setShowFileUploads(true)
        } else {
          setShowFileUploads(false)
        }

        //  setSelectedSchema(dbSchema[2].MainCategory)

        var cnt1 = 0;
        const schemaEdited2 = dbSchema[2].MainCategory.map((person: any, index: any) => {
          cnt1 = cnt1 + 1;
          var disableedit = false;
          var checkedView = false;

          if (selectedAction == "1") {
            disableedit = true;
            checkedView = true;
          }

          return {
            ...person,
            id: cnt1,//person.entId,
            chooseByUser: checkedView,
            disableView: disableedit
          };

        });

        setSelectedSchema(schemaEdited2);


        break;
      case "4": // sub category create
        setBatchId(action + "_" + formatDate(new Date()) + "_" + selectedBrand + "_" + maincategoryId)

        if (selectedAction == "1") {
          setShowFileUploads(true)
        } else {
          setShowFileUploads(false)
        }

        //  setSelectedSchema(dbSchema[3].SubCategory)

        var cnt1 = 0;
        const schemaEdited3 = dbSchema[3].SubCategory.map((person: any, index: any) => {
          cnt1 = cnt1 + 1;
          var disableedit = false;
          var checkedView = false;

          if (selectedAction == "1") {
            disableedit = true;
            checkedView = true;
          }

          return {
            ...person,
            id: cnt1 ,//person.entId,
            chooseByUser: checkedView,
            disableView: disableedit
          };

        });

        setSelectedSchema(schemaEdited3);

        break;
      case "5": //  for stock update

        
        setBatchId(action + "_" + formatDate(new Date()))

        setShowFileUploads(false)


        var cnt1 = 0;
        const schemaEdited4 = dbSchema[0].Product.map((person: any, index: any) => {

          console.log("werrrr :: " + person.name);

          cnt1 = cnt1 + 1;
          var disableedit = true;
          var checkedView = false;
          var hideItem = true;

          if (person.name == "vcProductCode" || person.name == "iStock") {
            hideItem = false;
            checkedView = true;
          }


          return {
            ...person,
            id: cnt1, //person.entId,
            chooseByUser: checkedView,
            disableView: disableedit,
            hideItem: hideItem
          };

        });

        setSelectedSchema(schemaEdited4);

        break;

      case "6": // for size create
          setBatchId(action + "_" + formatDate(new Date()))
  
          if (selectedAction == "1") {
            setShowFileUploads(true)
          } else {
            setShowFileUploads(false)
          }
  
          var cnt1 = 0;
          const schemaEdited5 = dbSchema[4].Size.map((person: any, index: any) => {
            cnt1 = cnt1 + 1;
            var disableedit = false;
            var checkedView = false;
            if (selectedAction == "1") {
              disableedit = true;
              checkedView = true;
            }
  
            return {
              ...person,
              id: cnt1, //person.entId,
              chooseByUser: checkedView,
              disableView: disableedit
            };
  
          });
  
          setSelectedSchema(schemaEdited5);
          break;

      case "7": // finish create
          setBatchId(action + "_" + formatDate(new Date()))
  
          if (selectedAction == "1") {
            setShowFileUploads(true)
          } else {
            setShowFileUploads(false)
          }
  
          var cnt1 = 0;
          const schemaEdited6 = dbSchema[5].Finish.map((person: any, index: any) => {
            cnt1 = cnt1 + 1;
            var disableedit = false;
            var checkedView = false;
            if (selectedAction == "1") {
              disableedit = true;
              checkedView = true;
            }
  
            return {
              ...person,
              id: cnt1, //person.entId,
              chooseByUser: checkedView,
              disableView: disableedit
            };
  
          });
  
          setSelectedSchema(schemaEdited6);
          break;
    }

  }, [selectedAction, selectedItem, selectedBrand, maincategoryId, subCategoryId])

  useEffect(() => {
    //console.log("outerLoop ", " : "+ Math.ceil(9/5));


    switch (selectedItem) {
      case "1": 
        setshowBrands(true)
        loadAllBrands();

        if (selectedAction == "2") { 

          setshowBrands(false)

          setshowMainCategories(false)
          //loadAllCategories(selectedBrand)

          setshowSubCategories(false)

          setshowFilePicker(true)

        } else {

          setshowMainCategories(true)
          //loadAllCategories(selectedBrand)

          setshowSubCategories(true)
        }


        loadAllCategories(selectedBrand)
        if (maincategoryId != 0) {
          loadSubCategories(maincategoryId)
        }

        if (subCategoryId != 0) {
          setshowFilePicker(true)
        }
        break;

      case "2":
        setshowFilePicker(true)
        setshowBrands(false)
        setshowMainCategories(false)
        setshowSubCategories(false)
        break;
      case "3":
        //setshowFilePicker(false)

        if (selectedBrand != 0) {
          setshowFilePicker(true)
        } else {
          setshowBrands(true)
          setshowSubCategories(false)
          loadAllBrands();

          setshowFilePicker(false)
        }
        break;
      case "4":
        setshowBrands(true)
        loadAllBrands();
        setshowMainCategories(true)
        setshowSubCategories(false)
        //loadAllCategories(selectedBrand)
        if (maincategoryId != 0) {
          setshowFilePicker(true)
        }
        break;

      case "5":

        setshowFilePicker(true)

        break;

      case "6":
        setshowFilePicker(true)
        setshowBrands(true)        
        loadAllBrands()
        setShowFileUploads(false)
        setshowMainCategories(false)
        setshowSubCategories(false)
        break; 
      case "7":
        setshowFilePicker(true)
        setshowBrands(true)
        loadAllBrands()
        setShowFileUploads(false)
        setshowMainCategories(false)
        setshowSubCategories(false)
        break; 

        default:
        break;
    }


  }, [selectedAction, selectedItem, selectedBrand, maincategoryId, subCategoryId])

  interface MyError {
    error: string;
  }
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState<MyError[]>([]);
  const handleCloseModal = () => {
    setShowModal(false);
  };


  const [open, setOpen] = useState(false);
  const [image, setImage] = useState("false");

  const handleClose = () => {
    setOpen(false);
  };

  const handleImage = () => {
    //setImage();
    setOpen(true);
    console.log(image);
  };

  // const [editableFields, setEditableFields] = useState<any>({});
  const updateFieldKeys = (key: number, event: SyntheticEvent) => {



    let fieldsData: any = [...selectedSchema];
    fieldsData[key].chooseByUser = (event.target as HTMLInputElement).checked;
    setSelectedSchema(fieldsData);

    var showImageupload = false;

    fieldsData.map((column: any, index: any) => {

      if (column.isFile && column.chooseByUser) {
        showImageupload = true;
      }

      console.log("colllll ::  ", column);

    });

    setShowFileUploads(showImageupload)


    console.log("weeeeeee :: " + JSON.stringify(selectedSchema));


  }

   
  const [openDlg, setDlgOpen] = useState(false);

  const handleDlgClose = () => {
    console.log("opppppppppppppppppppppppppppppppppp")
    setDlgOpen(false);
  };

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));

  interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
  }

  function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2, fontSize: 18 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }


  ///

  const navigateToDashboard = () => {

    navigate('../categories')
  }



  return (
    <div className="card md-12 ">
      <div className="card-header p-0 text-left">
        <label className='ml-1 mt-1'>Create / Update / Delete Bulk Jobs</label>
      </div>
      <div className="card-body ">
        <div className="row ">
          <div className="col-2 form-group text-left">
            <TextField select size="small" label="Action" className="form-control" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
              name='action' value={selectedAction} InputProps={{ sx: { height: 30 } }}
              onChange={(e: any) => {
                setSelectedAction(e.target.value)
                //loadAllCategories(e.target.value)
              }}  >
              <MenuItem value="0" key="select" selected disabled>Select</MenuItem>
              <MenuItem value="1" key="1">Bulk Create</MenuItem>
              <MenuItem value="2" key="2">Bulk Update</MenuItem>
              { /* <MenuItem value="3" key="3">Bulk Delete</MenuItem> */}

            </TextField>
          </div>
          <div className="col-2 form-group text-left">
            <TextField select size="small" label="Item" className="form-control" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
              name='item' defaultValue="select" value={selectedItem} InputProps={{ sx: { height: 30 } }}
              onChange={(e: any) => {
                setSelectedItem(e.target.value);
                setSelectedBrand(0)
                setMainCategoryId(0)
                setsubCategoryId(0)
                setshowBrands(false)
                setshowMainCategories(false)
                setshowFilePicker(false)


                setBatchId(formatDate(new Date())) // sai commented


                //showOptions(selectedAction, e.target.value, 0)
                //loadAllCategories(e.target.value)
              }}  >
              <MenuItem value="0" key="select" selected disabled>Select</MenuItem>
              <MenuItem value="1" key="1" hidden={!(selectedAction == "1") && !(selectedAction == "2")} >Product</MenuItem>
              <MenuItem value="2" key="2" hidden={!(selectedAction == "1")}  >Brand</MenuItem>
              <MenuItem value="3" key="3" hidden={!(selectedAction == "1")} >Main Category</MenuItem>
              <MenuItem value="4" key="4" hidden={!(selectedAction == "1")} >Sub Category</MenuItem>
              <MenuItem value="5" key="5" hidden={!(selectedAction == "2")}  >Stock</MenuItem>
              <MenuItem value="6" key="6" hidden={!(selectedAction == "1")}  >Size</MenuItem>
              <MenuItem value="7" key="7" hidden={!(selectedAction == "1")}  >Finish</MenuItem>


            </TextField>
          </div>
          {/*(selectedItem != "0") && <div className=" form-group  text-left">
          <TextField size="small" label="Batch Id" id="outlined-start-adornment" InputLabelProps={{ shrink: true  }} InputProps={{ sx: { height: 30  }  , readOnly:true  }  }
                   type="text" className="form-control" name='batchID' value={batchId}   />
            </div> */
          }
          {showBrands && <div className="col-2 form-group  text-left">

            <TextField select size="small" label="Brand Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
              className="form-control" name='brandId' defaultValue="select" value={selectedBrand} InputProps={{ sx: { height: 30 } }}
              onChange={(e: any) => {
                setSelectedBrand(e.target.value);
                setMainCategoryId(0)
                setsubCategoryId(0)
                //showOptions(selectedAction, selectedItem, e.target.value)
                setshowFilePicker(false)
                loadAllCategories(e.target.value);
              }}
            >
              <MenuItem disabled value="0" key="select">Select</MenuItem>
              {availableBrands.map((_el: any) => <MenuItem key={_el.brandId} value={_el.brandId}> {_el.brandName}</MenuItem>)}
            </TextField>


          </div>
          }
          {showMainCategories && <div className="col-2 form-group  text-left">

            <TextField select size="small" label="Main Category" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
              className="form-control" name='mainCat' defaultValue="select" value={maincategoryId} InputProps={{ sx: { height: 30 } }}
              onChange={(e: any) => {
                setMainCategoryId(e.target.value)
                setsubCategoryId(0)
                //showOptions(selectedAction, selectedItem, maincategoryId)
                //loadSubCategories(e.target.value);

              }}
            >
              <MenuItem disabled value="0" key="select1">Select</MenuItem>
              {availableCategories.map((_el: any) => <MenuItem key={_el.catId} value={_el.catId}> {_el.catName}</MenuItem>)}
            </TextField>

          </div>
          }
          {showSubCategories && <div className="col-2 form-group  text-left">

            <TextField select size="small" label="Sub Category" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
              className="form-control" name='subCat' defaultValue="select" value={subCategoryId} InputProps={{ sx: { height: 30 } }}
              onChange={(e: any) => {
                setsubCategoryId(e.target.value);

              }}
            >
              <MenuItem disabled value="0" key="select">Select</MenuItem>
              {availableSubCategories.map((_el: any) => <MenuItem key={_el.catId} value={_el.catId}> {_el.catName}</MenuItem>)}
            </TextField>

          </div>
          }

          {showFilePicker && (selectedItem != "0") && <div className="col-3 form-group  text-left">
            <TextField size="small" label="Batch Id" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 }, readOnly: true }}
              type="text" className="form-control" name='batchID' value={batchId} />
          </div>
          }

        </div>
      </div>
      {

        /*showFilePicker &&  <div className="ml-4">
          <p>Choose Fields - <span style={{color:'red'}}><i>i denotes Numeric Values, put without '' in file | vc denotes Text values, enclose within '' in file</i></span></p>
         <div className="row text-left ml-1 mr-1">
           {selectedSchema.map((el, index) => <div key={el.uuid} className=" m-1">
               
             <div className=" "  hidden={el.hideItem}   key={"" + index} ><input  readOnly={el.disableView}  checked={el.chooseByUser} onChange={(e) => updateFieldKeys(index, e)} type="checkbox" name={el.inputName} id={el.inputName} className='mr-2' /> {el.name}</div>
           
           </div>)
           }
   
         </div>
   
         </div> */

      }

      {showFilePicker && <div className="ml-4">
        <p>Choose Fields - <span style={{ color: 'red', fontSize: '1.5em' }}><sup><i> In FieldName i denotes Number ( put without " "  in file) | vc denotes Text ( enclose within " "  in file)</i></sup></span></p>
        <div className="row text-left ml-1 mr-1">
          {selectedSchema.map((el, index) => <div key={el.uuid} className=" m-1">

            <div hidden={el.hideItem} key={"" + index} ><input readOnly={el.disableView} checked={el.chooseByUser} onChange={(e) => updateFieldKeys(index, e)} type="checkbox" name={el.inputName} id={el.inputName} className='ml-2' /> {el.name}</div>

          </div>)
          }

        </div>

      </div>}


      {showFilePicker && <div className="row  bottom-border mt-4 ml-3 mb-4">

        <div className='col-4 text-left ' hidden={!showFileUploads}  >

          <TextField size="small" label="Upload Images" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} variant="outlined" type="text"
            className="form-control" name='featImg' value={fileLoadState} helperText={". jpg | . png | . pdf file"}
            InputProps={{
              sx: { height: 30 },
              endAdornment: (
                <IconButton component="label"  >
                  <FileUploadOutlinedIcon />
                  <input style={{ display: "none" }} multiple type="file" hidden onChange={onUploadFileList} name="featImgHiddenInput"
                  />
                </IconButton>
              ),
            }}
          />
        </div>

        <div className='col-4 text-left'>

          <TextField size="small" label="Upload Excel" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} variant="outlined" type="text"
            className="form-control" name='featImg' value={excelFile} helperText={" . csv file"}
            InputProps={{
              sx: { height: 30 },
              endAdornment: (
                <IconButton component="label"  >
                  <FileUploadOutlinedIcon />
                  <input style={{ display: "none" }} multiple type="file" hidden onChange={onUploadCsv} name="featImgHiddenInput"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                </IconButton>
              ),
            }}
          />
        </div>

        <div className='text-left ml-3 mt-1'>
          {/*<div><Link to="#" onClick={(e) => handleImage()} >Csv File Format</Link></div>*/}

        </div>

      </div>
      }


      <div style={{ height: '200px' }} className="mt-4 mb-4" hidden={!showFileUploads}  >

        {/* To List File */}
        <div className="row ml-4 mr-4 p-1" style={myComponent}>
          {filteredOrders && filteredOrders
            .map((getordersList: any, index: number) => {
              return (
                <tr key={index} className="border m-0 text-center pl-0" style={imgComponent} >
                  {/* 
                    <td> <img
                      style={{ width: "50px", height: "30px" }}
                      src={getordersList.imgurl}
                    ></img> </td>
                      */}
                  <td>{getordersList.fileName}</td>

                  <td> <span><i className="" aria-hidden="true">   </i>
                    <IconButton component="label" onClick={() => onRemoveFeature(index)}  >
                      <ClearIcon fontSize='small' htmlColor='red' />

                    </IconButton></span></td>


                </tr>
              );
            })}



        </div>

      </div>


      <div>
        {/* Upload Button */}

        <div className="card-footer col-12 text-center">
          <Button style={{ color: "green" }} className="mr-4" onClick={() => uploadAllfiles()} variant="text" startIcon={<ArrowUpwardRoundedIcon />}>
            Submit
          </Button>
          <Button style={{ color: "red" }} className="ml-4" onClick={navigateToDashboard} variant="text" startIcon={<ClearOutlinedIcon />}>
            Cancel
          </Button>
        </div>

      </div>

      <Modal
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

        }}
        open={open}
        onClose={handleClose}
        closeAfterTransition

        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={open} timeout={500} style={{
          outline: "none"
        }}>
          <img
            className="imghover"
            src={logo}
            alt="asd"
            style={{ maxHeight: "90%", maxWidth: "65%" }}
          />
        </Fade>
      </Modal>

      <ErrorModal show={showModal} handleClose={handleCloseModal}>
        <div>
          <h2>Errors:</h2>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Column</th>
                <th>Error</th>
                <th>Reason</th>
                <th>Value</th>
                <th>Row</th>
              </tr>
            </thead>
            <tbody>
              {errors.map((error, index) => (
                <tr key={index}>

                  <td>{error.error}</td>

                </tr>
              ))}
            </tbody>
          </table>
          {/* <ul>
            {errors.map((error, index) => (
              <li key={index}>
                Column: {error.column}, Error: {error.error}, Reason: {error.reason}, Value: {error.value}, Row: {error.row}
              </li>
            ))}
          </ul> */}
        </div>
      </ErrorModal>
      { /* <BootstrapDialog
                    onClose={handleDlgClose}
                    aria-labelledby="customized-dialog-title"
                    open={openDlg}>

                    <BootstrapDialogTitle id="customized-dialog-title" onClose={handleDlgClose}>
                    Invalid Filename!!!
                    </BootstrapDialogTitle>

                   <div className="m-2 pr-4 pl-2 pt-2"><p>File name should contain characters [a-z] , [A-Z] , [0-9] or Underscore [ _ ] </p> </div>

                    <DialogActions>
                   
                    </DialogActions>
                </BootstrapDialog> 
                */}

      {openDlg && <MyCustomNotification title="Invalid File!!!" message="File name should contain characters [a-z] , [A-Z] , [0-9] or Underscore [ _ ] " ></MyCustomNotification>}


      <ToastContainer />


      {isLoading && (
        <div className="loading-screen">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden"></span>
          </div>
        </div>
      )}

    </div >




  );
}

export default BatchProcessing;
